module.exports = __webpack_public_path__ + "img/header-memoireRingsFullSizeMemoires@2x.315c6bd.jpg";